import React, {useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';


import {enableWakeLock} from './WakeLock';
import HHCanvas from './components/HHCanvas';
import LoadingIndicator from "./components/LoadingIndicator";
import { ViewDescription } from './components/ViewDescription/ViewDescription';
import MainAppBar from './components/MainAppBar';
import DeveloperSidePanel from './components/DeveloperSidePanel';
import ViewControls from './components/ViewControls';
import { LangContext, LangContextDefault } from './context/LangContext';
/*import { Provider } from "./components/HHContext";

class App extends Component {
  constructor(props) {
    super( props );
    this.state = {
       language: '',
       view: '',
       handleLanguageChange: this.handleLanguageChange,
       handleViewChange: this.handleViewChange
    }
  }
}*/

const useStyles = makeStyles((theme) => createStyles({
  root: theme.mixins.toolbar, // pushes everything down to clear the toolbar
}));


enableWakeLock();

function App() {
  const [desiredOpacity, setDesiredOpacity] = useState(1);
  const [desiredView, setDesiredView] = useState(0);
  const [desiredPanels, setDesiredPanels] = useState(0);
  const [developerMode, setDeveloperMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showStats, setShowStats] = useState(false);
  const [lang, setLang] = useState(LangContextDefault);
  const classes = useStyles();
  //Do we need to manually trigger an update upon language change?

  const handlePanelChange = (event, newValue) => { setDesiredPanels(newValue); }
	const handleOpacityChange = (event, newValue) => { setDesiredOpacity(newValue); }
  const toggleDeveloperMode = () => { setDeveloperMode(!developerMode); }
  const MAXVIEW = 5;
  const nextView = () => {
    console.log("nextView: ",desiredView)
    switch (desiredView) {
      case 1:
        setDesiredView(2);
        break;
      default:
        setDesiredView((desiredView+1)%(MAXVIEW+1));
        break;
    }
    /* TODO: take desiredView and figure out what to setDesiredView to */
  }
  const prevView = () => {
    console.log("prevView: ",desiredView)
    /* TODO: take desiredView and figure out what to setDesiredView to */
    if (desiredView===0) {
      setDesiredView(MAXVIEW);
    } else {
      setDesiredView(desiredView-1);
    }
  }

  return <>
    <LangContext.Provider value={[lang, setLang]}>
      <MainAppBar toggleDeveloperMode={toggleDeveloperMode} setDesiredView={setDesiredView} />
      <main className={classes.root}>
      {loading ? <LoadingIndicator />: <></> }
      <ViewDescription view={desiredView} nextView={nextView} prevView={prevView} />
      <HHCanvas stats={showStats}  opacity={desiredOpacity} setDesiredOpacity={setDesiredOpacity} desiredView={desiredView} setDesiredView={setDesiredView} setLoading={setLoading} visiblePanels={desiredPanels} setDesiredPanels={setDesiredPanels} />
      {loading ? <></> : <ViewControls desiredView={desiredView} setDesiredView={setDesiredView} /> }
      {(developerMode) ? <DeveloperSidePanel handleOpacityChange={handleOpacityChange} desiredOpacity={desiredOpacity} setShowStats={setShowStats} /> : <></>}
      </main>
    </LangContext.Provider>
  </>;
}

export default App;

//    <ViewDescription view={desiredView} desiredPanels={desiredPanels} handlePanelChange={handlePanelChange} nextView={nextView} prevView={prevView} />